<template>
  <div id="tab-box" class="setting-item">
    <h3>画片类型:
      <!-- <span>{{pickedTitle}}</span> -->
    </h3>
    <div id="tab-header">
      <div :class="`nav-header${showBtn ? ' header-scroll' : ''}`">
        <div class="left btn"
             v-if="showBtn">
          <u-icon name="ChevronLeft"></u-icon>
        </div>
        <div class="right btn"
             v-if="showBtn">
          <u-icon name="ChevronRight"></u-icon>
        </div>
        <div class="nav-scroll">
          <div class="nav-box">
            <div v-for="(item, index) in tabList"
                 :key="index"
                 :class="`tab${index === pickedIndex ? ' cur' : ''}`"
                 @click="handleTabChange(item, index)">
              {{item.title}}
            </div>
          </div>
        </div>
      </div>
    </div>
    <div id="tab-content"
         class="over-scroll">
      <div class="image-box"
           :key='index'
           v-for="index in tabList[pickedIndex].num">
        <img :src="pickedImg(tabList[pickedIndex].name, index)"
             :alt="tabList[pickedIndex]+index">
      </div>
    </div>
  </div>
</template>
<script>
import pictureList from '@therapy/components/PictureTab/pictureslist.json'
export default {
  props: {
    descion: {
      type: Array,
    },
    config: {
      type: Object,
    },
  },
  data() {
    const tabList = pictureList.filter(this.descionFilter)
    return {
      showBtn: false,
      pickedIndex: 0,
      pickedTitle: tabList[0].title,
      tabList,
    }
  },
  computed: {
    imageInfo() {
      return {
        imageType: this.tabList[this.pickedIndex].name,
        imageNum: this.tabList[this.pickedIndex].num,
      }
    },
  },
  created() {
    this.$emit('update:config', { ...this.config, ...this.imageInfo })
  },
  methods: {
    handleTabChange(row, index) {
      this.pickedIndex = index
      this.pickedTitle = row.title
      this.$emit('update:config', { ...this.config, ...this.imageInfo })

    },
    descionFilter(pic) {
      return this.descion.includes(pic.name)
    },
    pickedImg: (name, index) =>
      `static/img/parametersImg/${name}/${index - 1}.png`,
  },
}
</script>
<style lang="scss" scoped>
@import '@src/styles/variables.scss';

#tab-box {
  height: 210px;
  display: flex;
  flex-direction: column;
  color: $color-text;
  #tab-header {
    position: relative;
    // margin: 0 0 10px;
    .nav-header {
      overflow: hidden;
      position: relative;
      height: $line-height-small-l;
      line-height: $line-height-small-l;
      &.header-scroll {
        padding: 0 20px;
      }
      .nav-scroll {
        overflow: hidden;
        .nav-box {
          white-space: nowrap;
          position: relative;
          float: left;
          z-index: 2;
          cursor: pointer;
          .tab {
            padding: 0 10px;
            font-size: $font-size-small-l;
            display: inline-block;
            height: $line-height-small-l;
            // border-bottom: 2px solid transparent;
            &.cur {
              border-top: 2px solid $color-text-title;
              background-color: $color-bg-opacity;
            }
          }
        }
      }
      .btn {
        position: absolute;
        cursor: pointer;
        font-size: $font-size-small-s;
        &.left {
          left: 0;
        }
        &.right {
          right: 0;
        }
      }
    }
  }

  #tab-content {
    flex: 1;
    font-size: 1.6rem;
    padding: 5px;
    display: flex;
    flex-wrap: wrap;
    background-color: $color-bg-opacity;

    .image-box {
      height: 50px;
      width: 50px;
      margin: 3px;
      img {
        width: 100%;
        height: 100%;
      }
      &:hover {
        width: 100px;
        height: 100px;
        // background: #55acee;
        border: 2px solid transparent;
        border-color: $color-text-title;
        z-index: 101;
      }
    }
  }
}
</style>


